import styled from 'styled-components'

export const AudioWaveWrapper = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`
